import {InjectionToken} from '@angular/core'

export const WINDOW = new InjectionToken<Window>('window')
export const LOCAL_STORAGE = new InjectionToken<Storage>('localStorage')
export const SESSION_STORAGE = new InjectionToken<Storage>('sessionStorage')
export const FILE_READER = new InjectionToken<FileReader>('fileReader')